import * as Sentry from '@sentry/react'
import { store } from 'store/store'
import { logout } from 'store/actions/sessionDataActions'

let logoutStarted = false

export const cleanAndLogout = () => {
  if (logoutStarted) return
  logoutStarted = true

  Sentry.addBreadcrumb({
    category: 'auth',
    message: 'Session rejected; redirecting to login',
    level: 'info',
  })
  store.dispatch(logout())
  window.localStorage.clear()
  window.sessionStorage.clear()
  window.location.replace('/login')
}
